import {Pipe, PipeTransform} from '@angular/core';
export class ObjToArrayPipe implements PipeTransform {
/**
 * @param {?} value
 * @param {?=} args
 * @return {?}
 */
transform(value: any, args?: any): any {
    const /** @type {?} */ objCtor = {}.constructor;
    if (value && value.constructor === objCtor) {
      return Object.keys(value)
        .map(key => {
          return {key, value: value[key]};
        });
    }
    return value;
  }

static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'objToArray'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ObjToArrayPipe_tsickle_Closure_declarations() {
/** @type {?} */
ObjToArrayPipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ObjToArrayPipe.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
